//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/Section.js";
import "../no/SelectFaceList.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"OffsetValueLinearDimension",0,"Expression",0],[1,"OffsetValueLinearDimensionNegativeX",0,"Expression",0],[1,"OffsetValueLinearDimensionNegativeY",0,"Expression",0],[1,"OffsetValueLinearDimensionPositiveX",0,"Expression",0],[1,"OffsetValueLinearDimensionPositiveY",0,"Expression",0],[1,"PadBoolean",0,"GeometricUtilities.BooleanOperation",0],[1,"PadHeightLinearDimension",0,"Expression",0],[0,"PreviousWorkPart",1,"Part",0],[1,"SelectComponent",0,"Assemblies.SelectComponent",0],[1,"SelectCurve",0,"Section",0],[1,"SelectFaces",0,"SelectFaceList",0],[1,"SelectPad",0,"Features.SelectFeatureList",0],[0,"Type",1,0]],[[[],"WaveFaces",{},0,0],[[],"DeleteWavedFaces",{},0,0]],[]];
SPLM.Tooling.BackingPadBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BackingPadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BackingPadBuilder.Types = Object.freeze({
    "KfBoundBox" : "KfBoundBox", "UserDefined" : "UserDefined", "DeletePad" : "DeletePad"});

export default SPLM;